import RoutesWrapper from './RoutesWrapper';

export default RoutesWrapper;
